import React from 'react';
import T from 'prop-types';
import { isEmpty, get } from 'lodash-es';

import skeletons from './Skeletons';
import DetailsEmpty from './DetailsEmpty';
import InstalledSdks from '../InstalledSdks';
import Button from '../../../../../components/Buttons/Button';

import links from '../../config/links';

const InsightsSDK = ({ details, settings }) => {
  const sdks = get(details, 'installed_sdks');
  const refNo = get(details, 'app_about.about_data.app_id', '');
  const filters = get(details, 'filters');

  if (settings.pending) return skeletons.detailsTable;

  const showData = (!settings.pending && !isEmpty(sdks));

  return (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">
        <div className="insights-details-block__head-left">
          Installed SDKs
        </div>
        {showData && (
          <Button
            size="sm"
            variant="secondary"
            href={links.sdks(filters.store, refNo)}
          >
            <span>View All</span>
            <i className="hicon-angle-down-alt" />
          </Button>
        )}
      </h4>
      <div className="insights-details-block__content">
        {showData ? <InstalledSdks sdks={sdks} store={filters.store} /> : <DetailsEmpty />}
      </div>
    </div>
  );
};

InsightsSDK.propTypes = {
  details: T.object,
  settings: T.object,
};

export default InsightsSDK;
